import getAPIResponse from "Shared/Utils/Domain/Services/GetAPIResponsePrivateService";
import { ServiceContractDelegation } from "../../Model/ServiceContractDelegation/ServiceContractDelegation";

export async function patchServiceContractDelegationService(id, data) {
    let response = await getAPIResponse("/v1/service-contract-delegation/" + id, data, "PATCH");
    if (response === null) {
        return null;
    }
    return ServiceContractDelegation.createFromResponseData(response);
}

